<ng-container *transloco="let t">
  <!-- Use flex with column direction and set a fixed height -->
  <div class="flex flex-col h-full max-h-[80vh]">
    <!-- Content section - scrollable -->
    <div class="flex-1 overflow-y-auto">
      <div class="mb-5">
        <p class="dark:text-surface-400">
          {{ getDescriptionText() }}
        </p>
      </div>
      <p-fluid>
        <form [formGroup]="form">
          <formly-form [form]="form" [model]="model" [fields]="fields"></formly-form>
        </form>
      </p-fluid>
    </div>

    <!-- Footer section - fixed -->
    <div class="flex-none mt-3 pt-3 border-t border-surface-200 dark:border-surface-700">
      <div class="flex flex-row flex-wrap gap-3 justify-end">
        <p-button [label]="t('app.common.cancel')" severity="secondary" (click)="ref.close()"></p-button>
        <p-button
          [label]="getSubmitButtonText()"
          [severity]="actionType === 'rejection' ? 'danger' : 'success'"
          [icon]="actionType === 'rejection' ? 'pi pi-times' : 'pi pi-check'"
          (click)="submitAction()"
          [disabled]="form.invalid || loading"
          [loading]="loading"
        >
        </p-button>
      </div>
    </div>
  </div>
</ng-container>
